<h1 mat-dialog-title
    i18n="@@clear-all-dialog.title">
    Achtung, möglicher Datenverlust!
</h1>

<mat-dialog-content i18n="@@clear-all-dialog.content">
    <p>
        <strong>Alle Daten löschen</strong>
    </p>
    <p>
        Wenn Sie auf "Alle Daten löschen" klicken, werden sämtliche Daten aus Ihrem Browser entfernt.
    </p>
    <p>
        Daten, die nicht mit "Daten speichern" exportiert wurden, sind unwiderbringlich verloren!
    </p>
</mat-dialog-content>

<mat-dialog-actions class="elohn-dialog-actions">
    <button mat-raised-button
            color="primary"
            cdkFocusInitial
            [mat-dialog-close]="false"
            i18n="@@global.abbrechen">Abbrechen</button>
    <button mat-button
            [mat-dialog-close]="true"
            i18n="@@clear-all-dialog.clearAll">Alle Daten löschen</button>
</mat-dialog-actions>
